import { useEffect } from "react";
import logger from "../utils/logger";
import config from "../config";

/**
 * useWebSocketConnection Hook
 * Phase 1 Day 45 - Extract WebSocket connection lifecycle
 *
 * Manages WebSocket connection and registration of message handler.
 * Connects on mount, disconnects on unmount.
 */
export function useWebSocketConnection({
  connectWebSocketStore,
  disconnectWebSocketStore,
  handleWebSocketMessage,
  handleWebSocketMessageRef,
}) {
  // Effect to manage WebSocket connection lifecycle via store
  useEffect(() => {
    logger.log("[AppContent] WebSocket connection useEffect running...");

    // Build WebSocket URL
    const wsUrl = config.websocketUrl;

    logger.log(`[AppContent] Connecting to WebSocket via store: ${wsUrl}`);
    connectWebSocketStore(wsUrl);

    return () => {
      logger.log("[AppContent] WebSocket cleanup - disconnecting from store");
      disconnectWebSocketStore();
    };
  }, [connectWebSocketStore, disconnectWebSocketStore]);

  // Keep the message handler ref in sync with the latest handleWebSocketMessage.
  // Registration is handled by AppContent.js (which registers once with empty deps
  // and proper unregister cleanup). This hook only updates the ref so the stable
  // wrapper created at registration time always calls the latest handler.
  useEffect(() => {
    handleWebSocketMessageRef.current = handleWebSocketMessage;
  });
}
